import React, { useEffect, useContext }from "react";
import { SessionContext } from "beaktShared/services/session";

export default function Dashboard() {  
  const session = useContext(SessionContext);

  const [imgbemvindo, set_imgbemvindo] = React.useState("");
  
  useEffect(() => {
    set_imgbemvindo(process.env.REACT_APP_API_ENDPOINT + "anexos/" + session.logoGrande);
  }, [session]);  

  return (
    <div>  
    
    <center>
      <div style={{padding:'20px',background: '#ffffffeb',borderRadius:'10px',maxWidth:'550px',margin:'100px auto'}}>
        <img  alt="logo" style={{width:'100%'}} src={imgbemvindo}/>
      </div>
    </center>
       
    </div>
  );
}
